<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import RoundChevronRight from 'virtual:icons/ic/round-chevron-right';
	import RoundChevronLeft from 'virtual:icons/ic/round-chevron-left';

	const dispatch = createEventDispatcher();

	let totalItems = 0,
		totalPages = 0,
		currentPage = 0,
		dataLabel = '',
		className = '';

	export { totalItems, totalPages, currentPage, dataLabel, className as class };
</script>

<div class="flex items-center justify-between {className}">
	<p class="text-sm">
		Total <span class="font-semibold">{totalItems} {dataLabel}</span>
	</p>
	<div class="flex items-center gap-1.5">
		<button
			disabled={currentPage === 1}
			on:click={() => dispatch('prev')}
			type="button"
			class="btn btn-circle btn-ghost"
			aria-label="Sebelumnya"
			title="Sebelumnya"
		>
			<RoundChevronLeft class="text-2xl" />
		</button>
		<p class="font-medium">{currentPage}/{totalPages}</p>
		<button
			disabled={currentPage === totalPages}
			on:click={() => dispatch('next')}
			type="button"
			class="btn btn-circle btn-ghost"
			aria-label="Selanjutnya"
			title="Selanjutnya"
		>
			<RoundChevronRight class="text-2xl" />
		</button>
	</div>
</div>
